<template>
	<div class="title-page">
		<h1 class="title">Mes logements</h1>
		<router-link to="/ajouter" class="button outline normal">Ajouter un logement</router-link>
	</div>
	<div v-if="filteredCils.length && !loading">
		<div v-if="filteredCils.length" class="head">
			<div class="dpe">DPE</div>
			<div class="name">Nom</div>
			<div class="address">Adresse</div>
			<div class="action">&nbsp;</div>
		</div>
		<div class="logement-list">
			<div class="logement-line" v-for="property in filteredCils" :key="property.id">
				<div class="dpe">
					<div :class="['dpe-letter', getDPEColor(property.Etiquette_DPE)]">{{
						getDPELetter(property.Etiquette_DPE, property.Etiquette_GES) }}</div>
				</div>
				<div class="name">{{ property.name }}</div>
				<div class="address">{{ property.address }}</div>
				<div class="action">
					<button v-if="property.status == 'unknown'" class="button fill normal"
						@click="openSubscription(property.ID)">Réactiver</button>
					<button v-else class="button fill normal" @click="fetchProperty(property.ID)">Voir le
						logement</button>
				</div>
				<div class="menu-container">
					<i class="bi bi-three-dots-vertical" @click="toggleMenu(property.ID)"></i>
					<div v-if="showMenuForPropertyId === property.ID" class="context-menu">
						<ul>
							<li @click="openPopupDelete(property.ID)">Supprimer</li>
							<li @click="openPopupTransfert(property)">Transférer</li>
						</ul>
					</div>
				</div>
			</div>
			<h1 v-if="pendingProperties.length" style="margin-top: 50px">CIL à accepter</h1>
			<div v-if="pendingProperties.length" class="head">
				<div class="dpe">DPE</div>
				<div class="name">Nom</div>
				<div class="address">Adresse</div>
				<div class="action">&nbsp;</div>
			</div>
			<div class="logement-line" v-for="property in pendingProperties" :key="property.id">
				<div class="dpe">
					<div :class="['dpe-letter', getDPEColor(property.Etiquette_DPE)]">{{
						getDPELetter(property.Etiquette_DPE, property.Etiquette_GES) }}</div>
				</div>
				<div class="name">{{ property.name }}</div>
				<div class="address">{{ property.address }}</div>
				<div class="action">
					<button class="button fill normal" @click="openPopupAccept(property)">Accepter</button>
				</div>
				<div class="menu-container"></div>
			</div>
		</div>
	</div>
	<div v-else-if="!loading">
		<p>Aucun abonnement trouvé.</p>
	</div>
	<div v-else class="loader"></div>
	<ConfirmationPopupDelete :isVisible="showPopupDelete" title="Confirmer la suppression"
		message="Êtes-vous sûr de vouloir de supprimer ce CIL ?<br/>Tout vos documents seront supprimés sans possibilité de récupération."
		confirmButtonText="Supprimer" @confirm="deleteCil" @cancel="closePopupDelete">
	</ConfirmationPopupDelete>
	<ConfirmationPopupAccept :isVisible="showAcceptPopup" title="Accepter le CIL"
		:message="`Êtes-vous sûr de vouloir accepter ce CIL ?<br />CIL : ${propertyToAccept.name}`"
		confirmButtonText="Accepter" @confirm="acceptCIL" @cancel="closePopupAccept">
	</ConfirmationPopupAccept>
	<ConfirmationPopupTransfert :isVisible="showPopupTransfert" :property="this.propertyToTransfert"
		confirmButtonText="Résilier" @confirm="confirmPopupTransfert" @cancel="closePopupTransfert">
	</ConfirmationPopupTransfert>
	<AjouterAbonnement :isVisible="showPaymentPopup" :propID="this.propertyToSubscription" @confirm="closePaymentPopup"
		@cancel1="closePaymentPopup">
	</AjouterAbonnement>

</template>

<script>
import ConfirmationPopupDelete from "@/components/ConfirmationPopup";
import ConfirmationPopupAccept from "@/components/ConfirmationPopup";
import ConfirmationPopupTransfert from "@/components/ConfirmationTransfert.vue";
import AjouterAbonnement from "@/components/AjouterAbonnement.vue";


export default {
	name: "MesLogements",
	components: {
		ConfirmationPopupDelete,
		ConfirmationPopupAccept,
		ConfirmationPopupTransfert,
		AjouterAbonnement
	},
	props: ['searchQuery'],
	data() {
		return {
			loading: false,
			properties: [],
			pendingProperties: [],
			showMenuForPropertyId: null,
			propertyToDelete: null,
			showPopupDelete: false,
			propertyToTransfert: {},
			showPopupTransfert: false,
			propertyToSubscription: null,
			showPaymentPopup: false,
			propertyToAccept: {},
			showAcceptPopup: false
		};
	},
	created() {
		this.loading = true;
		this.fetchAllProperties();
	},
	methods: {
		async fetchAllProperties() {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "logements", { method: "GET", credentials: "include", });
				const data = await response.json();
				// if (data.error) return window.location.href = "/login";
				this.properties = data;
				const response2 = await fetch(process.env.VUE_APP_API_URL + "logements/pending", { method: "GET", credentials: "include", });
				const data2 = await response2.json();
				this.pendingProperties = data2;

				if (data.length === 0 && data2.length === 0) return this.$router.push('/ajouter');
			} catch (error) {
				this.message = "Une erreur est survenue.";
			} finally {
				this.loading = false;
			}
		},
		async fetchProperty(id) {
			try {
				const response = await fetch(process.env.VUE_APP_API_URL + "logements/" + id, { method: "GET", credentials: "include", });
				const data = await response.json();
				if (data.error) return window.location.href = "/login";
				localStorage.setItem("currentProperty", JSON.stringify(data));
				this.$router.push('/').then(() => window.location.reload());
			} catch (error) {
				this.message = "Une erreur est survenue.";
			}
		},
		getDPELetter(dpe, ges) {
			const letters = [];
			if (dpe) letters.push(dpe);
			if (ges) letters.push(ges);

			if (letters.length === 0) return "-";

			return letters.sort()[letters.length - 1];
		},
		getDPEColor(letter) {
			switch (letter) {
				case "A":
					return "color-A";
				case "B":
					return "color-B";
				case "C":
					return "color-C";
				case "D":
					return "color-D";
				case "E":
					return "color-E";
				case "F":
					return "color-F";
				case "G":
					return "color-G";
				default:
					return "color-Z";
			}
		},
		toggleMenu(propertyId) {
			if (this.showMenuForPropertyId === propertyId) {
				this.showMenuForPropertyId = null;
			} else {
				this.showMenuForPropertyId = propertyId;
			}
		},
		closeMenu() {
			this.showMenuForPropertyId = null;
		},
		openPopupDelete(propID) {
			this.propertyToDelete = propID;
			this.showPopupDelete = true;
			this.closeMenu();
		},
		openPopupTransfert(property) {
			this.propertyToTransfert = property;
			this.showPopupTransfert = true;
			this.closeMenu();
		},
		closePopupDelete() {
			this.propertyToDelete = null;
			this.showPopupDelete = false;
		},
		closePopupTransfert() {
			this.propertyToTransfert = {};
			this.showPopupTransfert = false;
		},
		confirmPopupTransfert() {
			this.fetchAllProperties();
			this.closePopupTransfert();
		},
		async deleteCil() {
			await fetch(process.env.VUE_APP_API_URL + 'logements/delete', {
				method: 'POST',
				credentials: "include",
				headers: { 'Content-Type': 'application/json', },
				body: JSON.stringify({ propID: this.propertyToDelete }),
			});

			this.closePopupDelete();
			this.fetchAllProperties();
		},
		async acceptCIL() {
			await fetch(process.env.VUE_APP_API_URL + 'logements/accept', {
				method: 'POST',
				credentials: "include",
				headers: { 'Content-Type': 'application/json', },
				body: JSON.stringify({ propID: this.propertyToAccept.ID })
			});

			this.closePopupAccept();
			this.fetchAllProperties();
		},
		openPopupAccept(property) {
			this.propertyToAccept = property;
			this.showAcceptPopup = true;
		},
		closePopupAccept() {
			this.fetchAllProperties();
			this.showAcceptPopup = false;
		},
		openSubscription(subscriptionId) {
			this.propertyToSubscription = subscriptionId;
			this.showPaymentPopup = true;
		},
		closePaymentPopup() {
			this.fetchAllProperties();
			this.showPaymentPopup = false;
		}
	},
	computed: {
		filteredCils() {
			const query = this.searchQuery.toLowerCase();
			return this.properties.filter(cil =>
				cil.name.toLowerCase().includes(query) ||
				cil.address.toLowerCase().includes(query)
			);
		}
	},
};
</script>

<style scoped>
.head {
	display: flex;
	margin-bottom: 30px;
}

.head>div {
	padding-left: 25px;
	font-size: 14px;
	font-weight: bold;
	color: #a7a7a7;
}

.head>div:nth-child(-n + 2) {
	position: relative;
}

.head>div:nth-child(-n + 2)::after {
	content: "";
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 1px;
	height: 25px;
	background-color: #ccc;
}

.head .dpe {
	min-width: 50px;
}

.head .name {
	min-width: 225px;
}

.head .address {
	min-width: 225px;
}

.head .action {
	width: 175px;
}

.logement-list {
	display: flex;
	flex-direction: column;
	gap: 25px;
}

.logement-line {
	display: flex;
	align-items: center;
	background-color: #fff;
	border-radius: 15px;
	filter: drop-shadow(0 0 5px #d3d3d3);
	height: 60px;
}

.logement-line>div {
	padding: 0 25px;
}

.logement-line>div:nth-child(-n + 2) {
	position: relative;
}

.logement-line>div:nth-child(-n + 2)::after {
	content: "";
	position: absolute;
	right: 0;
	top: 50%;
	transform: translateY(-50%);
	width: 1px;
	height: 35px;
	background-color: #ccc;
}

.logement-line .dpe {
	display: flex;
	align-items: center;
	justify-content: center;
}

.logement-line .name {
	min-width: 200px;
	font-weight: bold;
}

.logement-line .address {
	min-width: 200px;
	flex: 1;
	font-weight: bold;
}

.logement-line .action {
	min-width: 150px;
	padding-right: 0px;
}

.menu-container {
	position: relative;
	display: inline-block;
}

.context-menu {
	position: absolute;
	top: 0px;
	left: -88px;
	background-color: white;
	outline: 1px solid #ccc;
	z-index: 1000;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
	font-size: 16px;
	border-radius: 6px;
	overflow: hidden;
	user-select: none;
}

.context-menu ul {
	list-style-type: none;
	margin: 0;
	padding: 0;
}

.context-menu ul li {
	padding: 4px 12px;
	cursor: pointer;
}

.context-menu ul li:hover {
	background-color: #f0f0f0;
}

@media (max-width: 1150px) {
	.head {
		display: none;
	}

	.logement-line {
		flex-direction: column;
		align-items: flex-start;
		height: auto;
		padding: 15px;
	}

	.logement-line>div {
		padding: 10px 0;
		width: 100%;
		border-bottom: 1px solid #ccc;
	}

	.logement-line>.menu-container {
		position: absolute;
		right: 20px;
		top: 0;
		width: 16px;
		border: none;
	}

	.context-menu {
		left: -112px;
	}

	.logement-line>div:nth-child(3) {
		border-bottom: none;
	}

	.logement-line>div:nth-last-child(-n + 2) {
		border-bottom: none;
	}

	.logement-line>div:nth-child(-n + 3)::after {
		display: none;
	}

	.dpe-letter {
		font-size: 18px;
		padding: 4px;
		width: 18px;
	}
}
</style>